import { FIELDS } from "lib"

export const ACCOUNT_TYPE_TABLE_COLUMNS = [
    { id: FIELDS.accountCode.key, label: FIELDS.accountCode.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.active.key, label: FIELDS.state.name },
]